import { render, staticRenderFns } from "./StakeholderSelection.vue?vue&type=template&id=d81faa9e"
import script from "./StakeholderSelection.vue?vue&type=script&lang=js"
export * from "./StakeholderSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports